<form [formGroup]="form()">
  <div class="w-3/4" hlmFieldGroup>
    <fieldset hlmFieldSet>
      <legend hlmFieldLegend>1. Informations pratiques</legend>
      <p hlmFieldDescription>
        Les informations qui contiennent la mention “requis” sont nécessaires pour la publication, pas pour
        l’enregistrement.
      </p>

      <div hlmFieldGroup>
        <div hlmField>
          <label hlmFieldLabel for="input-nom" labelRequired>Nom de l'activité</label>
          <input id="input-nom" hlmInput formControlName="nom" />
        </div>
        <div hlmField>
          <label hlmFieldLabel for="select-referentiel" labelRequired>Référentiel métier</label>
          <brn-select
            class="inline-block"
            id="select-referentiel"
            [compareWith]="compareWithId"
            formControlName="referentiel"
          >
            <hlm-select-trigger class="w-full">
              <hlm-select-value />
            </hlm-select-trigger>
            <hlm-select-content>
              @for (item of referentiels() | trierPar: 'nom'; track item.id) {
                <hlm-option [value]="item">{{ item.nom }}</hlm-option>
              }
            </hlm-select-content>
          </brn-select>
          <p hlmFieldDescription>Renseigné automatiquement en fonction de votre métier.</p>
        </div>
        <div hlmField>
          <label hlmFieldLabel for="select-modalite" labelRequired>Modalité</label>
          @if (modalites().length > 0) {
            <brn-select
              class="inline-block"
              id="select-modalite"
              [compareWith]="compareWithId"
              formControlName="modalite"
            >
              <hlm-select-trigger class="w-full">
                <hlm-select-value />
              </hlm-select-trigger>
              <hlm-select-content>
                @for (item of modalites() | trierPar: 'nom'; track item.id) {
                  <hlm-option [value]="item">{{ item.nom }}</hlm-option>
                }
              </hlm-select-content>
            </brn-select>
          } @else {
            <app-alerte
              message="Pour pouvoir sélectionner des modalités, il faut que les administrateurs en créent pour cette cartographie."
            />
          }
        </div>
        <div hlmField>
          <label hlmFieldLabel for="select-techniques" labelRequired>Techniques d'animation</label>
          @if (techniquesAnimation().length > 0) {
            <brn-select
              class="inline-block"
              id="select-techniques"
              [compareWith]="compareWithId"
              multiple
              formControlName="techniquesAnimation"
            >
              <hlm-select-trigger class="w-full">
                <hlm-select-value />
              </hlm-select-trigger>
              <hlm-select-content>
                @for (item of techniquesAnimation() | trierPar: 'libelle'; track item.id) {
                  <hlm-option [value]="item">{{ item.libelle }}</hlm-option>
                }
              </hlm-select-content>
            </brn-select>
          } @else {
            <app-alerte
              message="Pour pouvoir sélectionner des techniques d'animation, il faut que les administrateurs en créent pour cette cartographie."
            />
          }
        </div>
        <div hlmField>
          <label hlmFieldLabel for="select-lieu" labelRequired>Lieu</label>
          <brn-select class="inline-block" id="select-lieu" formControlName="lieu">
            <hlm-select-trigger class="w-full">
              <hlm-select-value />
            </hlm-select-trigger>
            <hlm-select-content>
              @for (item of lieux.values(); track item) {
                <hlm-option [value]="item">{{ item }}</hlm-option>
              }
            </hlm-select-content>
          </brn-select>
        </div>
        <div hlmField>
          <label hlmFieldLabel for="input-duree" labelRequired>Durée</label>
          <input id="input-duree" hlmInput formControlName="duree" type="number" inputmode="numeric" />
          <p hlmFieldDescription>Exprimée en heures.</p>
        </div>
        <div hlmField>
          <label hlmFieldLabel for="description" labelRequired>Description de l'activité</label>
          <textarea formControlName="description" hlmTextarea></textarea>
        </div>
      </div>
    </fieldset>
  </div>
</form>
